import { INDUSTRIES } from "../../data/industries";

const STATS = [
  { num: "₹3L+", label: "Monthly revenue recovered per client" },
  { num: "9", label: "Industries served with bespoke AI" },
  { num: "7", label: "Questions to your full AI roadmap" },
  { num: "5–7", label: "Days to live on WhatsApp" },
  { num: "24/7", label: "Aria works when your team doesn't" },
];

const IndustryCard = ({ data }) => (
  <article
    className={`industry-card reveal ${data.fullWidth ? "industry-full" : ""}`}
    data-testid={`industry-card-${data.key}`}
    style={{ gridColumn: data.fullWidth ? "1 / -1" : "auto" }}
  >
    {/* HERO IMAGE STRIP */}
    <div
      className={`industry-hero ${data.grad}`}
      style={{ backgroundImage: `url(${data.img})` }}
      role="img"
      aria-label={data.imgAlt}
    >
      <div className="industry-hero-tint" />
      <div className="industry-hero-grad" />
      <div className="industry-hero-content">
        <div className="industry-hero-top">
          <span className="industry-hero-icon" aria-hidden>{data.icon}</span>
          <span className="industry-hero-label">{data.label}</span>
        </div>
        <h3 className="industry-hero-title">{data.title}</h3>
        <p className="industry-hero-vision">{data.future.vision}</p>
      </div>
    </div>

    {/* SPLIT */}
    <div className="industry-split">
      {/* TODAY */}
      <div className="industry-today">
        <div>
          <div className="industry-today-tag">
            <span className="year">Today · 2025</span>
            <span>{data.label}</span>
          </div>
          <p className="industry-pain">{data.today.pain}</p>
          <ul className="industry-today-list">
            {data.today.bullets.map((b, i) => <li key={i}>{b}</li>)}
          </ul>
        </div>
        <div className="industry-cost">
          {data.today.cost}<br />
          <strong>{data.today.costNum}</strong>
        </div>
      </div>

      {/* 2036 */}
      <div className={`industry-future ${data.grad}`}>
        <span className="industry-year-watermark" aria-hidden>2036</span>
        <div>
          <div className="industry-future-tag">
            <span className="year">2036 · With Aria</span>
            <span>{data.title}</span>
          </div>
          <ul className="industry-future-list">
            {data.future.bullets.map((b, i) => <li key={i}>{b}</li>)}
          </ul>
        </div>
        <div className="industry-roi-badge">
          <span className="dot" />
          {data.future.roi}
        </div>
      </div>
    </div>
  </article>
);

const Industries = () => (
  <section id="industries" className="section bg-grey" data-bg="grey" data-testid="industries-section">
    <div className="section-inner">
      <div className="reveal">
        <span className="eyebrow">Industries we help</span>
        <h2 className="section-h2">
          Who we work <span className="serif">with</span>.
        </h2>
        <p className="section-sub">
          Aria builds custom AI + automation systems for eight mid-market
          industries in India — each with the exact intelligence and integrations
          that vertical needs. On the left, where you are today. On the right,
          where Aria takes you.
        </p>
      </div>

      <div className="industries-grid">
        {INDUSTRIES.map((d) => <IndustryCard key={d.key} data={d} />)}
      </div>

      <div className="stats-row reveal">
        {STATS.map((s, i) => (
          <div key={i} data-testid={`stat-${i}`}>
            <div className="stat-num">{s.num}</div>
            <div className="stat-label">{s.label}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Industries;
